export interface RNG {
  /** Returns a number in [0, 1). */
  next(): number;
}

/**
 * mulberry32 — small, fast, well-distributed PRNG. 32-bit state, suitable for
 * shuffles and statistical sims. NOT cryptographically secure.
 *
 * Reference: variants by Tommy Ettinger, public domain.
 */
export function mulberry32(seed: number): RNG {
  let a = seed >>> 0;
  return {
    next() {
      a = (a + 0x6d2b79f5) >>> 0;
      let t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4_294_967_296;
    },
  };
}

/** Default RNG backed by Math.random — non-deterministic, used in production. */
export function defaultRng(): RNG {
  return { next: () => Math.random() };
}
